<template>
  <div
    class="col-12"
    :class="gutterClass"
  >
    <div
      v-for="(mention, mentionIndex) in localMentions"
      :key="`${mention.type}-${mention.id}`"
      class="tw:flex tw:items-start tw:gap-2"
    >
      <BaseCheckbox
        v-if="showCheckbox"
        class="tw:mt-4 tw:shrink-0"
        data-testid="mention-checkbox"
        :model-value="selectedCompositeIds.has(`${mention.type}_${mention.id}`)"
        new-design
        @update:model-value="$emit('mention-selected', mention)"
      />
      <div class="tw:min-w-0 tw:flex-1">
        <MentionCardFactory
          action-sheet-component="ActionSheet"
          :data-testid="`mention-card-factory-${mention.id}`"
          :data-walkthrough-id="`stream-${index}-mention-${mentionIndex}`"
          :mention="mention"
          :mentions="localMentions"
          :no-highlighting="noHighlighting"
          :options="options"
          :product="product"
          :stream="stream"
          @click="openMention($event)"
          @contact-clicked="handleContactClicked"
          @mention-removed="removeMention"
        />

        <MatchingStreams
          v-if="mention.stream_ids"
          :mention="mention"
        />
      </div>
    </div>
    <div v-if="!localMentions.length && !showMoreContentOption">
      <slot name="emptyMentions">
        <MediaNotFoundCard
          class="q-pb-sm q-mt-md"
          :range="range"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import BaseCheckbox from "shared/components/core/forms/BaseCheckbox.vue";
import MatchingStreams from "shared/components/MatchingStreams.vue";
import MediaNotFoundCard from "shared/components/MediaNotFoundCard.vue";
import { propsExcept } from "shared/components/MentionCard";
import MentionCardFactory from "shared/components/MentionCardFactory";
import DateRange from "shared/helpers/DateRange";

export default {
  name: "MentionStreamList",
  components: {
    BaseCheckbox,
    MentionCardFactory,
    MediaNotFoundCard,
    MatchingStreams,
  },
  props: {
    ...propsExcept(["mention", "mentions", "actionSheetComponent"]),
    gutterClass: {
      type: String,
      default: "q-gutter-sm",
    },
    index: {
      type: Number,
      default: 0,
    },
    mentions: {
      type: Array,
      required: true,
    },
    product: {
      type: String,
      default: null,
    },
    range: {
      type: DateRange,
      default: () => DateRange.lastThirtyDays(),
    },
    selectedCompositeIds: {
      type: Set,
      default: () => new Set(),
    },
    showCheckbox: {
      type: Boolean,
    },
    showMoreContentOption: {
      type: Boolean,
    },
  },
  emits: [
    "mention-clicked",
    "mention-removed",
    "mention-selected",
    "contact-clicked",
  ],
  data() {
    return {
      localMentions: [],
    };
  },
  watch: {
    mentions: {
      deep: true,
      handler(mentions) {
        this.localMentions = [...mentions];
      },
    },
  },
  mounted() {
    this.localMentions = [...this.mentions];
  },
  methods: {
    openMention(mention) {
      this.$emit("mention-clicked", mention);
    },
    removeMention(mention) {
      this.$emit("mention-removed", mention);
    },
    handleContactClicked(contact, componentId) {
      this.$emit("contact-clicked", contact, componentId);
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  font-size: 12px;
}

.card {
  &.warning {
    h3 {
      margin: 12px 0;
    }

    .q-icon {
      vertical-align: -3px;
    }
  }
}

.dashed-underline {
  border-bottom: 1px dashed red;
}

.scoped:deep(.mention-dropdown) {
  .q-btn-inner > .q-icon {
    font-size: 20px;
  }
}
</style>
